module.exports = __webpack_public_path__ + "img/logitech_meetup_mount.eeb09e2b.png";